module.exports = __webpack_public_path__ + "img/open_in_new-24px.a8f6b51f.svg";